import * as S from './styles';
import { mapGetters } from 'vuex';

import Dropdown from '@/components/Common/Dropdown';
import InputField from '@/components/Common/InputField';
import CommonButton from '@design/components/button/Button';
import { SelectedBox } from '@/components/Common/DropdownBox';
// import {
//     ChannelFilter,
//     AdAccountFilter,
//     LabelFilter,
// } from '@/components/Dashboard/common/SearchBar/filters';
import FieldDropdown from '@/components/Dashboard/common/UaFilterSettingPanel/FieldDropdown';
import MultiInputField from '@/components/Common/MultiInputField';

import TrashIcon from '@svgIcons/trash.svg';
import CloseIcon from '@svgIcons/close.svg';

import FilterFormatterMixin from '@/components/Dashboard/common/UaFilterSettingPanel/mixin';

// import { isValueExist } from '@util';
import {
    checkHasLevel,
    getOuterConditions,
} from '@/components/Dashboard/common/Filter/utils';

import {
    DEFAULT_AND_OR_FILTER,
    NOT_OPERATOR,
    COMPLEMENT_OPERATOR_MAP,
    OUTER_CONDITIONS_PATH,
    // ALL_OPERATOR_AVAILABLE_GENERIC_SOURCES,
} from '@/components/Dashboard/common/Filter/const';
import {
    // OPERATOR_LIST_MAP,
    INPUT_TYPES,
    VALUE_INPUT_TYPE_MAP,
    DEFAULT_OPERATOR_MAP,
    OBJECTIVE_DISCARD_OPTIONS,
    // TITLE_LEVEL,
    OPERATOR_LIST_TYPES,
    DATASTREAM_FIELD_OPTIONS,
} from '@/components/Dashboard/common/SearchBar/filters/const';
import { FILTER_KEYS } from '@/utils/consts';
import { isValueExist } from '@/utils/utils';
import {
    AdAccountFilter,
    ChannelFilter,
} from '@/components/Dashboard/common/SearchBar/filters';
import {
    getRefinedField,
    getRefinedLevel,
} from '@/components/Common/FilterInfo/utils';

const { CHANNEL, AD_ACCOUNT_ID, LABEL, OBJECTIVE, GENERIC } = FILTER_KEYS;
// const { CAMPAIGN, AD_ACCOUNT } = TITLE_LEVEL;
// const STARTS_OPERATOR_AVAILABLE_TITLE_LEVELS = [CAMPAIGN, AD_ACCOUNT];

const FILTER_COMP = {
    [CHANNEL]: ChannelFilter,
    [AD_ACCOUNT_ID]: AdAccountFilter,
};

export default {
    name: 'FilterItem',
    mixins: [FilterFormatterMixin],
    props: {
        filterData: {
            type: Object,
            default: R.always({}),
        },
        groupIdx: {
            type: Number,
        },
        path: {
            type: Array,
        },
        filterList: {
            type: Array,
        },
        updateFilterList: {
            type: Function,
        },
        discardFieldOptions: {
            type: Array,
            default: () => [],
        },
        genericLevelOptions: {
            type: Array,
            default: () => [],
        },
        discardGenericLevelOptions: {
            type: Array,
            default: () => [],
        },
        groupSourceType: {
            type: String,
        },
        breakdownListByChannel: {
            type: Object,
            default: () => ({}),
        },
        categoryListByPrefix: {
            type: Object,
            default: () => ({}),
        },
        genericLevelTranslator: {
            type: Function,
            default: R.identity,
        },
    },
    watch: {
        clientAndAdAccounts: {
            handler(nextObj) {
                const { dashboardClient, adAccounts } = nextObj;

                const objectiveList = dashboardClient.getObjectiveList
                    ? dashboardClient.getObjectiveList(adAccounts)
                    : [];

                this.objectiveList = R.compose(
                    R.reverse,
                    R.sort((_a, _b) => {
                        const a = _a?.toLowerCase();
                        const b = _b?.toLowerCase();

                        const aExist = this.$te(
                            `FILTERS.${OBJECTIVE}_option_${a}}`
                        );
                        const bExist = this.$te(
                            `FILTERS.${OBJECTIVE}_option_${b}`
                        );

                        if (aExist === bExist) return 0;
                        if (aExist) return 1;
                        if (bExist) return -1;
                    }),
                    R.filter(
                        (v) =>
                            v &&
                            !R.includes(
                                v.toLowerCase(),
                                OBJECTIVE_DISCARD_OPTIONS
                            )
                    )
                )(objectiveList);
            },
            deep: true,
            immediate: true,
        },
    },
    data() {
        return {
            operatorVisible: false,
            valueVisible: false,
            objectiveList: [],
            isComposing: false,
        };
    },
    computed: {
        ...mapGetters('newDashboard', ['adAccounts']),
        clientAndAdAccounts: R.compose(
            R.pick(['dashboardClient', 'adAccounts'])
        ),
    },
    methods: {
        handleFieldInput(value) {
            const { filterData, path, filterList } = this;

            const prevField = getRefinedField(filterData);

            if (prevField === value) return;

            const hasLevel = checkHasLevel(value) || value === GENERIC;
            const defaultOperator = R.prop(value, DEFAULT_OPERATOR_MAP);

            const newFilterData = R.mergeLeft(
                {
                    field:
                        value === GENERIC || value === LABEL
                            ? undefined
                            : value,
                    values: undefined,
                    operator: hasLevel ? undefined : defaultOperator,
                    not: false,
                },
                filterData
            );

            const updatedFilters = R.assocPath(path, newFilterData, filterList);

            this.updateFilterList(updatedFilters);
        },
        handleLevelInput(value) {
            const { filterData, path, filterList } = this;

            const { field } = filterData;
            const defaultOperator = R.prop(field, DEFAULT_OPERATOR_MAP);

            const newFilterData = R.mergeLeft(
                {
                    level: value,
                    operator: defaultOperator,
                    not: false,
                },
                filterData
            );

            const updatedFilters = R.assocPath(path, newFilterData, filterList);

            this.updateFilterList(updatedFilters);
            this.fieldVisible = false;
        },
        handleOperatorInput({ value }) {
            const { filterData, path, filterList } = this;

            const not = R.includes(value, NOT_OPERATOR);
            const operator = not ? COMPLEMENT_OPERATOR_MAP[value] : value;
            const newFilterData = R.mergeLeft({ not, operator }, filterData);

            const updatedFilters = R.assocPath(path, newFilterData, filterList);

            this.updateFilterList(updatedFilters);
            this.operatorVisible = false;
        },
        handleValueInput(_value) {
            const { filterData, path, filterList } = this;

            const value = Array.isArray(_value) ? _value : [_value];

            const newFilterData = R.assoc('values', value, filterData);

            const updatedFilters = R.assocPath(path, newFilterData, filterList);

            this.updateFilterList(updatedFilters);
        },
        handleLabelValueInput(value) {
            const { filterData, path, filterList } = this;
            const { dimensionId, labelId } = value;

            const newFilterData = R.mergeLeft(
                { field: dimensionId + '', values: [labelId + ''] },
                filterData
            );

            const updatedFilters = R.assocPath(path, newFilterData, filterList);

            this.updateFilterList(updatedFilters);
        },
        handleRemoveFilterItem() {
            const { path, filterList, groupIdx } = this;
            let updatedFilters = R.dissocPath(path, filterList);

            const filterGroups = getOuterConditions(updatedFilters);

            const filterItems = R.pathOr(
                [],
                [0, 'conditions', groupIdx, 'conditions'],
                updatedFilters
            );

            if (filterItems.length === 0 && filterGroups.length === 1) {
                // filterGroup이 없는 경우 전체 삭제
                updatedFilters = DEFAULT_AND_OR_FILTER;
            } else if (filterItems.length === 0) {
                // filterItem이 없는 경우 groupIdx 삭제
                const updatedConditions = filterGroups.filter(
                    (_, idx) => idx !== groupIdx
                );

                updatedFilters = R.assocPath(
                    OUTER_CONDITIONS_PATH,
                    updatedConditions,
                    filterList
                );
            }

            this.updateFilterList(updatedFilters);
        },
        renderSelectedItem({ value, formattedValue, showTooltip, isLabel }) {
            return (
                <S.SelectedItem showAllContent={!showTooltip}>
                    <S.SelectedText class="adriel-ellipsis">
                        {formattedValue}
                    </S.SelectedText>
                    {!isLabel && (
                        <CloseIcon
                            v-view-box
                            onClick={(e) => {
                                const _values = R.propOr(
                                    [],
                                    'values',
                                    this.filterData
                                );
                                const values = R.without([value], _values);

                                e.stopPropagation();
                                this.handleValueInput(values);
                                this.valueVisible = false;
                            }}
                        />
                    )}
                </S.SelectedItem>
            );
        },
        getInputDom(type) {
            const { filterData } = this;
            const { field, values = [] } = filterData;

            const refinedField = getRefinedField(filterData);

            switch (type) {
                case INPUT_TYPES.INPUT: {
                    return (
                        <div class="multi-value-input">
                            <MultiInputField
                                values={values}
                                placeholder={this.$t(
                                    'NEW_DASHBOARD.multi_input_placeholder'
                                )}
                                onKeydown={(e) => {
                                    const newValue = R.compose(
                                        R.trim,
                                        R.pathOr('', ['target', 'value'])
                                    )(e);

                                    if (
                                        e.key === 'Enter' &&
                                        !e.isComposing &&
                                        newValue
                                    ) {
                                        const newValues = [...values, newValue];
                                        this.handleValueInput(newValues);

                                        return;
                                    }
                                }}
                                onBlur={(e) => {
                                    const newValue = R.compose(
                                        R.trim,
                                        R.pathOr('', ['target', 'value'])
                                    )(e);

                                    if (newValue) {
                                        const newValues = [...values, newValue];
                                        this.handleValueInput(newValues);
                                    }
                                }}
                                onDeleteIdx={(idx) => {
                                    const newValues = R.remove(idx, 1, values);
                                    this.handleValueInput(newValues);
                                }}
                            />
                        </div>
                    );
                }
                case INPUT_TYPES.DROPDOWN: {
                    let VALUES = R.compose(
                        R.values,
                        R.pathOr({}, [field, 'value'])
                    )(DATASTREAM_FIELD_OPTIONS);

                    if (field === OBJECTIVE) {
                        VALUES = this.objectiveList;
                    }

                    const inputValue = R.prop(0, values);

                    const valueTranslator = this.getValueTranslator(field);
                    const formattedValue = valueTranslator(inputValue);

                    return (
                        <div class="value-dropdown" ref="valueWrapper">
                            <Dropdown
                                itemStyle={{ height: '36px' }}
                                value={formattedValue}
                                placeholder={this.$t(
                                    'NEW_DASHBOARD.dropdown_placeholder'
                                )}
                                options={VALUES}
                                formatter={valueTranslator}
                                visible={this.valueVisible}
                                onVisibleChange={(v) => {
                                    this.valueVisible = v;
                                }}
                                onInput={({ value }) => {
                                    this.handleValueInput(value);
                                    this.valueVisible = false;
                                }}
                                getPopupContainer={() =>
                                    this.$refs.valueWrapper
                                }
                            />
                        </div>
                    );
                }
                case INPUT_TYPES.DROPDOWN_CHECKBOX_INPUT: {
                    const Filter = FILTER_COMP[refinedField];
                    const isLabel = refinedField === LABEL;

                    const inputValues = isValueExist(values)
                        ? isLabel
                            ? [values[0]]
                            : values
                        : undefined;

                    const valueTranslator =
                        this.getValueTranslator(refinedField);

                    const showTooltip = !isLabel;

                    return (
                        <div class="value-checkbox-dropdown-wrapper">
                            <SelectedBox
                                placeholder={this.$t(
                                    'NEW_DASHBOARD.dropdown_placeholder'
                                )}
                                selectedOption={inputValues}
                                customItemRenderer={(values) => (
                                    <S.SelectedItemWrapper>
                                        {values.map((value) => {
                                            const formattedValue =
                                                valueTranslator(value, field);

                                            return this.wrapTooltip({
                                                visible: showTooltip,
                                                content:
                                                    this.renderSelectedItem({
                                                        value,
                                                        isLabel,
                                                        showTooltip,
                                                        formattedValue,
                                                    }),
                                                title: formattedValue,
                                            });
                                        })}
                                    </S.SelectedItemWrapper>
                                )}
                                onClick={() => {
                                    this.valueVisible = !this.valueVisible;
                                }}
                            />
                            {this.valueVisible && (
                                <Filter
                                    class="value-checkbox-dropdown"
                                    handleSubmit={({ value }) => {
                                        if (refinedField === LABEL) {
                                            this.handleLabelValueInput(value);
                                        } else {
                                            this.handleValueInput(value);
                                        }
                                        this.valueVisible = false;
                                    }}
                                    onUpdateAdAccountList={(v) => {
                                        this.adAccountList = v;
                                    }}
                                    selectedOption={inputValues}
                                    enableBlock={false}
                                    filterVisible={this.valueVisible}
                                    isNewFilterUI={true}
                                />
                            )}
                        </div>
                    );
                }
                default:
                    return null;
            }
        },
        handleClickOutside(e) {
            if (
                !e?.target?.closest(
                    '.value-checkbox-dropdown-wrapper, .value-dropdown'
                )
            ) {
                this.valueVisible = false;
            }
        },
        addEventListeners() {
            document.addEventListener('mousedown', this.handleClickOutside);
        },
        removeEventListeners() {
            document.removeEventListener('mousedown', this.handleClickOutside);
        },
        handleGenericLevelInput(value) {
            const { filterData, path, filterList } = this;

            const defaultOperator = R.prop(GENERIC, DEFAULT_OPERATOR_MAP);

            const newFilterData = R.mergeLeft(
                {
                    dataSourceType: GENERIC,
                    type: undefined,
                    field: value,
                    level: undefined,
                    values: undefined,
                    operator: defaultOperator,
                    not: false,
                },
                filterData
            );

            const updatedFilters = R.assocPath(path, newFilterData, filterList);

            this.updateFilterList(updatedFilters);
        },
    },
    mounted() {
        this.addEventListeners();
    },
    beforeDestroy() {
        this.removeEventListeners();
    },
    render() {
        const {
            filterData,
            discardFieldOptions,
            discardGenericLevelOptions,
            groupSourceType,
            genericLevelOptions,
            breakdownListByChannel,
            categoryListByPrefix,
            genericLevelTranslator,
        } = this;
        const { field, operator: _operator, not } = filterData;

        const refinedField = getRefinedField(filterData);
        const refinedLevel = getRefinedLevel(filterData);

        const inputType = VALUE_INPUT_TYPE_MAP[refinedField];
        const inputDoms$ = this.getInputDom(inputType);

        const isFieldEmpty = !refinedField;
        const hasLevel = checkHasLevel(field) || refinedField === GENERIC;
        const isLevelEmpty = hasLevel && !refinedLevel;
        const isFieldIncompleted = isFieldEmpty || isLevelEmpty;

        const defaultOperator = R.prop(refinedField, DEFAULT_OPERATOR_MAP);
        const operator = R.compose(
            this.operatorTranslator,
            R.ifElse(
                () => not,
                R.prop(R.__, COMPLEMENT_OPERATOR_MAP),
                R.when(
                    () => !isFieldIncompleted,
                    (v) => v || defaultOperator
                )
            )
        )(_operator);

        const operatorOptions = OPERATOR_LIST_TYPES.INLIKE;

        return (
            <S.Content>
                <FieldDropdown
                    filterData={this.filterData}
                    handleConfirmField={this.handleFieldInput}
                    handleConfirmLevel={this.handleLevelInput}
                    handleGenericLevelInput={this.handleGenericLevelInput}
                    genericLevelOptions={genericLevelOptions}
                    breakdownListByChannel={breakdownListByChannel}
                    categoryListByPrefix={categoryListByPrefix}
                    discardFieldOptions={discardFieldOptions}
                    discardGenericLevelOptions={discardGenericLevelOptions}
                    groupSourceType={groupSourceType}
                    genericLevelTranslator={genericLevelTranslator}
                />
                <div class="operator-dropdown" ref="operatorWrapper">
                    <Dropdown
                        itemStyle={{ height: '36px' }}
                        class={`${isFieldIncompleted ? 'disabled' : ''}`}
                        disabled={isFieldIncompleted}
                        value={operator}
                        placeholder={this.$t(
                            'NEW_DASHBOARD.dropdown_placeholder'
                        )}
                        options={Object.values(operatorOptions)}
                        formatter={this.operatorTranslator}
                        visible={this.operatorVisible}
                        onVisibleChange={(v) => {
                            this.operatorVisible = v;
                        }}
                        onInput={this.handleOperatorInput}
                        getPopupContainer={() => this.$refs.operatorWrapper}
                    />
                </div>
                {isFieldIncompleted ? (
                    <InputField
                        class="disabled"
                        placeholder={this.$t('NEW_DASHBOARD.input_placeholder')}
                        disabled={true}
                        resizable={false}
                    />
                ) : (
                    inputDoms$
                )}
                <CommonButton
                    class="remove-item-btn"
                    type="white"
                    css={S.ApplyRemoveBtnCss}
                    onClick={this.handleRemoveFilterItem}
                >
                    <TrashIcon v-view-box />
                </CommonButton>
            </S.Content>
        );
    },
};
